import { BarcodeDetector as o } from "./pure.js";
import { setZXingModuleOverrides as d } from "./pure.js";
var e;
(e = globalThis.BarcodeDetector) != null || (globalThis.BarcodeDetector = o);
export { d as setZXingModuleOverrides };